var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2494 16.4976C15.6638 16.4976 15.9998 16.8334 15.9998 17.2476C15.9998 17.6273 15.7175 17.9411 15.3512 17.9907L15.2494 17.9976H4.75009C4.33569 17.9976 3.99976 17.6618 3.99976 17.2476C3.99976 16.8679 4.28204 16.5541 4.64827 16.5044L4.75009 16.4976H15.2494ZM10.0061 1.99939C10.3859 1.99939 10.6999 2.28154 10.7495 2.64762L10.7564 2.74939L10.7558 12.9424L13.7233 9.97181C13.9895 9.7053 14.4063 9.68071 14.7002 9.89829L14.7844 9.97083C15.0511 10.2369 15.0757 10.6535 14.858 10.9473L14.7854 11.0315L10.5407 15.2821L10.47 15.3446L10.379 15.4032L10.3426 15.4244L10.2513 15.4623L10.1308 15.4924L10.0615 15.5003L10.0014 15.5023C9.95129 15.5023 9.90039 15.4968 9.85065 15.4862L9.76974 15.4631C9.67368 15.4321 9.58653 15.3818 9.51235 15.3171L5.22086 11.0324C4.92763 10.7397 4.92729 10.2648 5.22011 9.9717C5.4863 9.70524 5.90313 9.68074 6.19703 9.89838L6.28124 9.97094L9.2551 12.9384L9.25572 2.74939C9.25572 2.33518 9.59166 1.99939 10.0061 1.99939Z",
    fill: "#323130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.39d238f59c8b7efe6d5f5f69046c8680.svg";
export { ForwardRef as ReactComponent };